import { useEffect, useRef, useState } from "react";
import { client } from "@/lib/api";

// Renders a Bearer-auth'd image (e.g. /api/stickers/{id}/image) by fetching it as a blob through the
// authed axios client and swapping in an object URL. Falls back to nothing on error.
export function AuthImage({ src, alt = "", className, testid }) {
  const [url, setUrl] = useState(null);
  const objectUrlRef = useRef(null);

  useEffect(() => {
    let cancelled = false;
    if (objectUrlRef.current) { URL.revokeObjectURL(objectUrlRef.current); objectUrlRef.current = null; }
    setUrl(null);
    if (!src) return undefined;
    client
      .get(src, { responseType: "blob" })
      .then((res) => {
        if (cancelled) return;
        const obj = URL.createObjectURL(res.data);
        objectUrlRef.current = obj;
        setUrl(obj);
      })
      .catch(() => { /* leave blank on failure */ });
    return () => {
      cancelled = true;
      if (objectUrlRef.current) { URL.revokeObjectURL(objectUrlRef.current); objectUrlRef.current = null; }
    };
  }, [src]);

  if (!url) return <span className={className} data-testid={testid} aria-hidden />;
  return <img src={url} alt={alt} className={className} data-testid={testid} loading="lazy" />;
}
